import { toSearchParams } from '@shigo-ui/api-client';
import type { SupplyAppsListFilter } from './model';

export type SupplyAppStatusCountsFilter = Pick<
  SupplyAppsListFilter,
  'searchTerm' | 'publisherIds' | 'platformIds' | 'iabCategoryIds'
>;

export function supplyAppStatusCountsFilter(
  filter: SupplyAppsListFilter,
): SupplyAppStatusCountsFilter {
  return {
    searchTerm: filter.searchTerm.trim(),
    publisherIds: filter.publisherIds,
    platformIds: filter.platformIds,
    iabCategoryIds: filter.iabCategoryIds,
  };
}

export function serializeSupplyAppStatusCountsFilter(filter: SupplyAppStatusCountsFilter) {
  return toSearchParams({
    searchTerm: filter.searchTerm,
    publisherIds: filter.publisherIds,
    platformIds: filter.platformIds,
    iabCategoriesIds: filter.iabCategoryIds,
  });
}
